// Removes url parameters that should not be used in the GraphQL queries.
export const sanitizeFilterValues = (ignoreValues) => (debouncedValue) => {
  if (!ignoreValues || !debouncedValue) {
    return debouncedValue;
  }

  return {
    ...debouncedValue,
    f: Object.keys(debouncedValue.f).reduce((acc, val) => {
      if (ignoreValues.indexOf(val) !== -1) {
        return acc;
      }
      return {
        ...acc,
        [val]: debouncedValue.f[val],
      };
    }, {}),
  };
};

// Ensures url parameters stay in the url even if they've been filtered out of
// the GraphQL query.
export const sanitizeUrlValues = (ignoreValues) => (
  debouncedValue,
  transformedValue,
) => {
  if (!ignoreValues || !transformedValue) {
    return transformedValue;
  }

  const urlValue = {
    ...transformedValue,
    f: {
      ...transformedValue.f,
    },
  };

  ignoreValues.forEach((val) => {
    if (val in debouncedValue.f) {
      urlValue[val] = debouncedValue.f[val];
    }
  });

  return urlValue;
};

export const transformPathToName = (path) => {
  const pathToUse = path.startsWith('/') ? path.slice(1) : path;

  // Split the path by slashes
  const parts = pathToUse.split('/');

  // Capitalize the first letter of each part and join them together
  return parts
    .filter((part) => part.toLowerCase() !== 'team')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
};

const filterNonEmptyFields = (data) => {
  const isNonEmptyArray = (value) => Array.isArray(value) && value.length > 0;
  const isNonEmptyObject = (value) =>
    typeof value === 'object' &&
    value !== null &&
    Object.keys(value).length > 0;
  const isNonEmptyValue = (value) => value !== null && value !== '';

  const filterData = (obj) =>
    Object.entries(obj).reduce((acc, [key, value]) => {
      if (isNonEmptyArray(value)) {
        acc[key] = value;
      } else if (isNonEmptyObject(value)) {
        const nestedFilteredData = filterData(value);
        if (Object.keys(nestedFilteredData).length > 0) {
          acc[key] = nestedFilteredData;
        }
      } else if (isNonEmptyValue(value)) {
        acc[key] = value;
      }
      return acc;
    }, {});

  return filterData(data);
};

export const getChangedFields = (prev, current) => {
  const filteredPrev = filterNonEmptyFields(prev);
  const filteredCurrent = filterNonEmptyFields(current);

  return Object.entries(filteredCurrent).reduce(
    (acc, [key, currentValue]) => {
      const prevValue = filteredPrev[key];

      if (JSON.stringify(prevValue) !== JSON.stringify(currentValue)) {
        return {
          filterName: key,
          filterValue: currentValue,
        };
      }
      return acc;
    },
    {
      filterName: null,
      filterValue: null,
    },
  );
};
